/*
 * Fairyglim Pretty Girl Kit: Klammer, Charm(s), Scrunchie, Haarkamm (Leo oder Beige) wählen, Beauty Bag (Kosmetiktasche) und
 * To Go Bag sind fest dabei. Jedes Teil kommt als eigene Zeile in den Warenkorb (der Bestand stimmt). Die sechs Kit-Zeilen tragen die
 * versteckte Eigenschaft "_bundle" = "pretty-girl-kit:<Kennung>"; der automatische Rabatt "Pretty Girl Kit" (Shopify Function)
 * rechnet damit den Festpreis. Der erste gewählte Charm (keine Kette) gehört zum Kit; weitere Charms und alle Ketten-Charms
 * (Feld k, Kollektion CHARM KETTEN) kommen OHNE "_bundle" zum Einzelpreis dazu.
 * Reihenfolge der Charm-Reiter: Theme-Einstellung "Reihenfolge der Reiter" (Theme-Einstellungen > Fairyglim Charm Bar). Diese Datei ist eine Liquid-Datei, damit sie die Einstellung lesen kann.
 */
(function () {
  var root = document.querySelector('[data-bb]');
  var dataEl = document.querySelector('[data-bb-data]');
  if (!root || !dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var BUNDLE = parseInt(root.getAttribute('data-bundle'), 10) || 0;
  var NOTE_LABEL = root.getAttribute('data-note-label') || 'Wo soll dein Charm befestigt werden?';
  var money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: root.getAttribute('data-currency') || 'EUR' });
  function eur(c) { return money.format(c / 100); }
  function q(s) { return root.querySelector(s); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cleanClip(t) { return t.replace(/haarklammer/gi, '').replace(/\s+(XS\/S|XS|XL|L|M|S)\s*(?=\|)/i, ' ').replace(/\|/g, '').replace(/\s+/g, ' ').trim() || t; }
  function cleanCharm(t) { return t.replace(/charms?/gi, '').replace(/\|/g, '').replace(/\s+/g, ' ').trim() || t; }
  function cleanScr(t) { return t.replace(/\|/g, '').replace(/\s+/g, ' ').trim(); }
  function cleanComb(t) { return t.replace(/haarkamm/gi, 'Haarkamm').replace(/\|/g, '').replace(/\s+/g, ' ').trim(); }

  var LIMIT_CLIPS = 8, LIMIT_CHARMS = 10;
  var KNOWN = { 'gruppe-favorites': 'Favorites', 'gruppe-ocean-vibe': 'Ocean Vibe', 'gruppe-aesthetik': 'Aesthetic', 'gruppe-fun-food': 'Sweet Treats', 'gruppe-nazar': 'Nazar', 'gruppe-ketten': 'Ketten' };
  var KNOWN_ORDER = String("Favorites, Aesthetic, Ketten, Sweet Treats, Nazar, Ocean Vibe").split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  function labelOfTag(tag) { return tag.replace('gruppe-', '').split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' '); }

  var cats = {}, order = [];
  data.charms.forEach(function (c) {
    var groups = c.g ? c.g.split(',').filter(Boolean) : [];
    var names = groups.length ? groups.map(function (g) { return KNOWN[g] || labelOfTag(g); }) : ['Sonstiges'];
    names.forEach(function (n) { if (!cats[n]) { cats[n] = []; order.push(n); } cats[n].push(c); });
  });
  order.sort(function (a, b) {
    var ia = KNOWN_ORDER.indexOf(a.toLowerCase()), ib = KNOWN_ORDER.indexOf(b.toLowerCase());
    if (a === 'Sonstiges') return 1;
    if (b === 'Sonstiges') return -1;
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  });

  var SIZE_ORDER = ['XS/S', 'M', 'L', 'XL'];
  var haveSizes = SIZE_ORDER.filter(function (s) { return data.clips.some(function (c) { return c.size === s; }); });
  var state = { size: haveSizes.indexOf('L') > -1 ? 'L' : (haveSizes[0] || 'Alle'), cat: order[0], clip: null, charms: [], scr: null, comb: null, moreClips: false, moreCharms: false };

  var elSizes = q('[data-sizes]'), elClips = q('[data-clips]'), elCats = q('[data-cats]'), elCharms = q('[data-charms]');
  var elScr = q('[data-scr]'), elCombs = q('[data-combs]'), elStage = q('[data-stage-img]'), elStack = q('[data-stack]');
  var elSel = q('[data-sel]'), elName = q('[data-name]'), elNote = q('[data-note]'), elAdd = q('[data-add]'), elMsg = q('[data-msg]');
  var elSum = q('[data-sum]'), elTotal = q('[data-total]'), elSave = q('[data-save]');

  var charmHint = elCharms && elCharms.parentNode && elCharms.parentNode.querySelector('h3 small');
  if (charmHint) charmHint.textContent = 'der erste ist inklusive, weitere und Ketten zum Einzelpreis';

  /* Der enthaltene Charm ist der erste gewählte Charm, der keine Kette ist. */
  function includedIdx() {
    for (var i = 0; i < state.charms.length; i++) { if (!state.charms[i].k) return i; }
    return -1;
  }

  function chip(label, thumb, pressed, wide) {
    var b = el('button', 'fgh-chip' + (wide ? ' fgh-chip--wide' : ''), (thumb ? '<span class="fgh-thumb"><img src="' + esc(thumb) + '" alt="" loading="lazy"></span>' : '') + '<span>' + esc(label) + '</span>');
    b.type = 'button';
    b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    return b;
  }
  function moreBtn(text, fn) { var m = el('button', 'fgh-more', text); m.type = 'button'; m.onclick = fn; return m; }

  function clipVisible(c) { return state.size === 'Alle' ? true : c.size === state.size; }
  function renderSizes() {
    elSizes.innerHTML = '';
    var labels = haveSizes.slice();
    if (!labels.length) { elSizes.hidden = true; return; }
    labels.push('Alle');
    labels.forEach(function (s) {
      var bt = el('button', null, esc(s));
      bt.type = 'button'; bt.setAttribute('role', 'tab'); bt.setAttribute('aria-selected', s === state.size);
      bt.onclick = function () { state.size = s; state.moreClips = false; renderSizes(); renderClips(); };
      elSizes.appendChild(bt);
    });
  }
  function renderClips() {
    elClips.innerHTML = '';
    var list = data.clips.filter(clipVisible);
    var shown = (!state.moreClips && list.length > LIMIT_CLIPS) ? list.slice(0, LIMIT_CLIPS) : list;
    if (state.clip && list.indexOf(state.clip) > -1 && shown.indexOf(state.clip) < 0) shown = shown.concat([state.clip]);
    shown.forEach(function (c) {
      var b = chip(cleanClip(c.t), c.th, state.clip === c);
      b.onclick = function () { state.clip = state.clip === c ? null : c; renderClips(); render(); };
      elClips.appendChild(b);
    });
    if (!list.length) elClips.appendChild(el('p', 'fgh-empty', 'In dieser Größe ist gerade nichts verfügbar.'));
    if (shown.length < list.length) elClips.appendChild(moreBtn('Alle ' + list.length + ' Klammern anzeigen', function () { state.moreClips = true; renderClips(); }));
  }
  function renderCats() {
    elCats.innerHTML = '';
    order.forEach(function (c) {
      var b = el('button', null, esc(c));
      b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', c === state.cat);
      b.onclick = function () { state.cat = c; state.moreCharms = false; renderCats(); renderCharms(); };
      elCats.appendChild(b);
    });
  }
  function renderCharms() {
    elCharms.innerHTML = '';
    var items = cats[state.cat] || [];
    var shown = (!state.moreCharms && items.length > LIMIT_CHARMS) ? items.slice(0, LIMIT_CHARMS) : items;
    shown.forEach(function (c) {
      var b = chip(cleanCharm(c.t) + (c.k ? ' (+ ' + eur(c.p) + ')' : ''), c.img, state.charms.indexOf(c) > -1);
      b.onclick = function () {
        var i = state.charms.indexOf(c);
        if (i > -1) state.charms.splice(i, 1); else state.charms.push(c);
        renderCharms(); render();
      };
      elCharms.appendChild(b);
    });
    if (shown.length < items.length) elCharms.appendChild(moreBtn('Alle ' + items.length + ' Charms anzeigen', function () { state.moreCharms = true; renderCharms(); }));
  }
  function renderScr() {
    elScr.innerHTML = '';
    data.scr.forEach(function (s) {
      var b = chip(cleanScr(s.t), s.th, state.scr === s, true);
      b.onclick = function () { state.scr = state.scr === s ? null : s; renderScr(); render(); };
      elScr.appendChild(b);
    });
    if (!data.scr.length) elScr.appendChild(el('p', 'fgh-empty', 'Gerade ist kein Scrunchie verfügbar.'));
  }
  function renderCombs() {
    elCombs.innerHTML = '';
    data.combs.forEach(function (c) {
      var b = chip(c.label || cleanComb(c.t), c.th, state.comb === c, true);
      b.onclick = function () { state.comb = state.comb === c ? null : c; renderCombs(); render(); };
      elCombs.appendChild(b);
    });
    if (!data.combs.length) elCombs.appendChild(el('p', 'fgh-empty', 'Gerade ist kein Haarkamm verfügbar.'));
  }

  function parts() {
    var out = [];
    var inc = includedIdx();
    if (state.clip) out.push({ kind: 'Klammer', o: state.clip, name: cleanClip(state.clip.t), img: state.clip.th });
    state.charms.forEach(function (c, i) {
      var isInc = i === inc;
      out.push({ kind: isInc ? 'Charm' : (c.k ? 'Ketten-Charm' : 'Zusatz-Charm'), o: c, name: cleanCharm(c.t), img: c.img, extra: !isInc });
    });
    if (state.scr) out.push({ kind: 'Scrunchie', o: state.scr, name: cleanScr(state.scr.t), img: state.scr.th });
    if (state.comb) out.push({ kind: 'Haarkamm', o: state.comb, name: cleanComb(state.comb.t), img: state.comb.th });
    data.fixed.forEach(function (f) { out.push({ kind: f.k, o: f, name: cleanScr(f.t), img: f.img, fixed: true }); });
    return out;
  }
  function complete() { return !!(state.clip && includedIdx() > -1 && state.scr && state.comb); }

  var lastImg = null;
  function render() {
    var list = parts();
    var sum = list.reduce(function (a, p) { return a + p.o.p; }, 0);
    var extras = list.reduce(function (a, p) { return a + (p.extra ? p.o.p : 0); }, 0);
    var kitSum = sum - extras;
    var total = (BUNDLE > 0 ? Math.min(kitSum, BUNDLE) : kitSum) + extras;
    var saved = sum - total;
    elName.textContent = state.clip ? 'Pretty Girl Kit mit ' + cleanClip(state.clip.t) : 'Dein Pretty Girl Kit';
    elSum.textContent = eur(sum);
    elSum.className = saved > 0 ? '' : 'is-same';
    elTotal.textContent = eur(total);
    var onlyChains = state.charms.length > 0 && includedIdx() < 0;
    elSave.hidden = !(complete() && saved > 0) && !onlyChains;
    if (onlyChains) elSave.textContent = 'Wähle noch einen Charm, der nicht zu den Ketten gehört: Er ist im Kit inklusive.';
    else if (!elSave.hidden) elSave.textContent = 'Du sparst ' + eur(saved) + ' gegenüber dem Einzelkauf.' + (extras > 0 ? ' Zusatz-Charms und Ketten sind darin zum Einzelpreis enthalten.' : '');
    elSel.innerHTML = '';
    list.forEach(function (p) {
      var li = el('li');
      li.innerHTML = (p.img ? '<img src="' + esc(p.img) + '" alt="">' : '<span class="fgh-mini"></span>') + '<span class="nm">' + esc(p.kind + ': ' + p.name) + '</span><span class="pr' + (p.fixed ? ' free' : '') + '">' + (p.fixed ? 'dabei' : eur(p.o.p)) + '</span>';
      elSel.appendChild(li);
    });
    elStack.innerHTML = '';
    list.slice(1).forEach(function (p) {
      if (!p.img) return;
      var sp = el('span', null, '<img src="' + esc(p.img) + '" alt="">');
      elStack.appendChild(sp);
    });
    var img = state.clip ? state.clip.img : '';
    if (img && lastImg !== img) {
      lastImg = img;
      if (elStage.getAttribute('src')) {
        elStage.classList.add('is-swap');
        setTimeout(function () { elStage.src = img; elStage.onload = function () { elStage.classList.remove('is-swap'); }; }, 160);
      } else { elStage.src = img; }
    } else if (!img) { lastImg = null; elStage.removeAttribute('src'); }
    elAdd.disabled = !complete();
    elMsg.hidden = true;
  }

  function buildItems() {
    var id = 'pgk' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var key = 'pretty-girl-kit:' + id;
    var note = (elNote.value || '').trim();
    function props(extra) {
      var p = { '_bundle': key, 'Pretty Girl Kit': 'Teil deines Pretty Girl Kits' };
      for (var k in extra) p[k] = extra[k];
      return p;
    }
    var inc = includedIdx();
    var first = state.charms[inc];
    var names = state.charms.map(function (c) { return cleanCharm(c.t); }).join(', ');
    var clipProps = props({ '_Charm-Check': state.charms.length + ' Charm(s) gewählt: ' + names });
    if (note) clipProps[NOTE_LABEL] = note;
    var items = [
      { id: state.clip.id, quantity: 1, properties: clipProps },
      { id: first.id, quantity: 1, properties: props({}) },
      { id: state.scr.id, quantity: 1, properties: props({}) },
      { id: state.comb.id, quantity: 1, properties: props({}) }
    ];
    data.fixed.forEach(function (f) { items.push({ id: f.id, quantity: 1, properties: props({}) }); });
    // Zusatz-Charms und Ketten: Einzelpreis, bewusst ohne _bundle (zählen nicht zum Festpreis)
    state.charms.forEach(function (c, i) {
      if (i === inc) return;
      items.push({ id: c.id, quantity: 1, properties: { 'Zusatz-Charm zum Pretty Girl Kit': 'ja' } });
    });
    return items;
  }

  elAdd.onclick = function () {
    if (!complete()) return;
    elAdd.disabled = true;
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: buildItems() };
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && j.description || 'add failed'); return j; }); })
      .then(function (j) {
        if (cartEl && j.sections && typeof cartEl.getSectionsToRender === 'function') {
          cartEl.getSectionsToRender().forEach(function (s) {
            var html = j.sections[s.id]; if (!html) return;
            var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector || '.shopify-section');
            var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
            if (parsed && target) target.innerHTML = parsed.innerHTML;
          });
          if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
        }
        if (cartEl && typeof cartEl.open === 'function') cartEl.open();
        elMsg.textContent = 'Dein Pretty Girl Kit liegt im Warenkorb. Wir packen es von Hand und „piercen“ deinen Charm.';
        elMsg.hidden = false;
        elAdd.disabled = false;
      })
      .catch(function (e) {
        elMsg.textContent = (e && e.message && /sold|stock|verfügbar|available/i.test(e.message)) ? 'Eines der Teile ist gerade nicht mehr verfügbar. Bitte wähle ein anderes.' : 'Das hat nicht geklappt. Bitte versuche es noch einmal.';
        elMsg.hidden = false;
        elAdd.disabled = false;
      });
  };

  renderSizes(); renderClips(); renderCats(); renderCharms(); renderScr(); renderCombs(); render();
})();
